var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-ueditor-wrap',{attrs:{"config":_vm.ueditorConfig},on:{"input":_vm.outInput},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }